import { render, staticRenderFns } from "./EMProduzioneLayoutAdapter.vue?vue&type=template&id=74d153c6&scoped=true&"
import script from "./EMProduzioneLayoutAdapter.vue?vue&type=script&lang=js&"
export * from "./EMProduzioneLayoutAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d153c6",
  null
  
)

export default component.exports